import { render, staticRenderFns } from "./TargetGroupModal.vue?vue&type=template&id=937799bc&scoped=true&"
import script from "./TargetGroupModal.vue?vue&type=script&lang=js&"
export * from "./TargetGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroupModal.vue?vue&type=style&index=0&id=937799bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937799bc",
  null
  
)

export default component.exports